import { Box, Dialog, DialogContent, DialogTitle, Grid, Typography } from '@material-ui/core'
import React, { useContext, useEffect, useState } from 'react'
import { makeStyles } from "@material-ui/core/styles";
import WarningIcon from "@material-ui/icons/Warning";
import exclamationIcon from "assets/exclamation.png";
import MROButton from "components/buttons";
import { MaintenanceServices } from 'lib/services/api/operaitons/WorkShop/TaskLibrary/Maintenance/maintenance_operation';
import { ToastMessageContext } from 'lib/contexts/message_context';
import { BASE_API_URL_BOXP } from 'lib/constants';
import { useCroppedSecondPage } from 'views/Operations/Base/Inprogress/Certification/useCroppedPage';
import { Document, Page, pdfjs } from "react-pdf";


const useStyles = makeStyles((theme) => ({
    message: {
        display: "flex",
        justifyContent: "flex-start",
        margin: theme.spacing(1),
        paddingLeft: "10px",
        marginBottom: "3px"
    },
    modal: {
        "& .MuiDialog-paperWidthSm": {
            minWidth: "850px",
        },
    },
    message: {
        display: "flex",
        justifyContent: "flex-start",
        margin: theme.spacing(1)
    },
}));




export default function QuotePreview(props) {

    const classes = useStyles()
    const { handleClose, open, popupValues, workshopOrderId, payload, quotationId, sendQuotations, handleWarningDialog, setQuoteId, getQuotation, setInternalFiles, internalFiles, setReportableType, projectState } = props
    const [acceptAll, setAcceptAll] = useState(null)
    const [isBusy, setIsBusy] = useState(false)
    const [closureData, setClosureData] = useState({})
    const [preview, setPreview] = useState(false)
    const message = useContext(ToastMessageContext)
    const InfoRow = ({ label, value, underline = false }) => (
        <Grid xs={12} container style={{ marginBottom: "7px", marginLeft: "18px" }}>

            <Grid xs={2}>
                <Typography variant="subtitle2">{label}</Typography>
            </Grid>
            <Grid xs={6}>
                <Typography style={underline ? { textDecoration: 'underline' } : {}}>
                    {value}
                </Typography>
            </Grid>
        </Grid>
    );



    const getPreviewFile = async () => {
        setIsBusy(true)
        const params = {
            preview: true,
            approved: null,
            save_later: false,
            quotation_id: quotationId ?? ""

        }
        getQuotationFile(params)
    }
    const getQuotationFile = async (params) => {
        try {

            const response = await MaintenanceServices.createQuotationAndPreview(params, payload)
            if (response) {
                setClosureData(response)
                setQuoteId(response?.quotation_id)
                setInternalFiles([])
                getQuotation(response?.quotation_id)
                if (projectState) { setReportableType("WorkshopOrder") }
            }
        }
        catch (error) {
            message.showToastMessage({
                message: "Something went wrong",
                variant: "error",
            });
        }
        finally {

            setIsBusy(false)
        }

    }

    const handleCancel = () => {
        const params = {

            preview: true,
            approved: false,
            save_later: false,
            quotation_id: quotationId ?? ""

        }
        if (internalFiles.length === 0) {
            for (const key of [...payload.keys()]) {
                if (key === "internal_files[]") {
                    payload.delete(key);
                }
            }
        }
        getQuotationFile(params)
        handleClose()
        handleWarningDialog()
    }


    useEffect(() => {
        if (workshopOrderId) {
            getPreviewFile()
        }
    }, [workshopOrderId])


    const pdfUrl = closureData?.preview_file?.file_path
        ? `${BASE_API_URL_BOXP.replace(/\/$/, "")}${closureData?.preview_file?.file_path}`
        : null;


    // Call hook here — top level, not inside useEffect
    const croppedPdfUrl = useCroppedSecondPage(pdfUrl);


    const handleComplete = () => {
        const params = {
            preview: false,
            approved: true,
            save_later: false,
            quotation_id: quotationId ?? ""
        }

        if (internalFiles.length === 0) {
            for (const key of [...payload.keys()]) {
                if (key === "internal_files[]") {
                    payload.delete(key);
                }
            }
        }

        sendQuotations(params, payload)
        handleClose()
    }


    return (
        <Dialog
            aria-labelledby="crs-dialog-title"
            // onClose={handleCloseHandler}
            open={open}
            className={classes.modal}
        >
            <DialogTitle id="crs-dialog-title">
                <Box style={{ display: "flex", justifyContent: "space-between" }}>
                    <Box display="flex" alignItems="center">
                        <Typography
                            style={{ fontSize: "18px", marginLeft: "11px" }}
                            color="primary"
                        >
                            Quotation - Preview & Accept
                        </Typography>


                    </Box>
                    <br />

                    <Box display="flex" justifyContent="center">
                        <img src={exclamationIcon} alt="Icon" />
                    </Box>
                </Box>
            </DialogTitle>

            <DialogContent style={{ marginTop: '-32px' }} >
                <div className={classes.message}>
                    <WarningIcon
                        style={{
                            color: "#FFB300",
                            marginRight: "1px",
                            fontSize: 20,
                        }}
                    />&nbsp;&nbsp;You are about to submit the following figures directly to the customer:
                </div>

                {isBusy ? (
                    <Grid style={{ textAlign: "center", margin: "30px 0px", fontSize: "14px" }}>
                        <Typography className={classes.header}>
                            The Reports for the job are being prepared
                        </Typography>
                        <img width={"150px"} src={"/loader.gif"} alt={"loading..."} />
                        <Typography className={classes.footer}>
                            Please be patient, this will take a few moments
                        </Typography>
                    </Grid>

                ) : <>
                    <Grid container xs={12} style={{
                        marginTop: "20px", marginBottom: "10px"
                    }}>


                        <InfoRow label="TAT" value={popupValues?.tat_days} />
                        <InfoRow label="Labour" value={popupValues?.labour_value} />
                        <InfoRow label="Parts" value={popupValues?.parts_value} />
                        <InfoRow label="Services" value={popupValues?.service_value} />
                        <InfoRow label="Equipment" value={popupValues?.equipment_value} />
                        <InfoRow label="Other" value={popupValues?.aog_fee} />
                        <InfoRow label="Shipping" value={popupValues?.shipping} />
                        <InfoRow
                            label="Total"
                            value={popupValues?.total ? parseFloat(popupValues.total).toFixed(2) : ''}
                            underline />
                    </Grid>
                    <div className={classes.message} key={`caution-quote`}>
                        <WarningIcon
                            style={{ color: "#FFB300", marginRight: 8, fontSize: 18, marginTop: "2px" }}
                        />
                        Preview the <a style={{ textDecoration: "underline", paddingLeft: 5, paddingRight: 5 }} onClick={() => setPreview(!preview)}>{closureData?.report_name || "Quotation Report"}  </a> and check the details are correct
                    </div>
                    {preview &&
                        <Box style={{ flex: 2, marginLeft: "-19px", pointerEvents: "none" }}>
                            <Document file={croppedPdfUrl || pdfUrl}>
                                {Array.from(new Array(closureData?.preview_file?.total_pages || 1), (_, index) => (
                                    <Page
                                        key={index}
                                        pageNumber={index + 1}
                                        scale={1.4} // auto-fit dialog
                                        renderTextLayer={false}
                                        renderAnnotationLayer={false}
                                    />
                                ))}
                            </Document>
                        </Box>}

                    {/* Accept all checkbox */}
                    <Box pt={3} pl={"21px"} display="flex" alignItems="center">
                        <span style={{ textDecoration: "underline" }}>Accept all</span>
                        &nbsp;&nbsp;&nbsp;
                        <input
                            type="checkbox"
                            checked={acceptAll}
                            // style={{ pointerEvents: hasFailures ? "none" : "auto" }}
                            onChange={() => setAcceptAll(!acceptAll)}
                        />
                    </Box>
                </>}
                <Box
                    mt="auto"
                    display="flex"
                    justifyContent="center"
                    style={{ marginTop: "20px", marginBottom: "20px" }}
                >
                    <MROButton
                        style={{ marginRight: "20px" }}
                        type="button"
                        variant={"contained"}
                        onClick={() => handleCancel()}
                        buttonName="Cancel"
                    >
                        Cancel
                    </MROButton>
                    <MROButton
                        type="button"
                        variant={"contained"}
                        color={"primary"}
                        style={{ backgroundColor: !acceptAll ? "#FFB300" : "", color: acceptAll ? "#ffff" : "#000000" }}
                        onClick={(e) => {
                            acceptAll && handleComplete(e);

                        }}
                        name="complete1"
                    >
                        Complete
                    </MROButton>
                </Box>
            </DialogContent>




        </Dialog>
    )
}
